var React = require("react");
var $ = require('jquery');
var _ = require('underscore');

// Actions
var JobActions = require('../actions/job_actions');

// Stores
var JobStore = require('../stores/job_store');

// Helpers
//var ViewHelper = require('../helpers/view');

// Components
var JobCategories = require('./job_categories');
var JobPublishDate = require('./job_publish_date');
var JobAuthor = require('./job_author');
var JobShare = require('./job_share');
var OtherJobs = require('./apply_other_jobs');
var JobApplyButton = require('./job_apply_button');
var PoweredBy = require('./powered_by');
var JobCallbackButton = require('./job_callback_button');

// Header
module.exports = React.createClass({
		
	// Render
  	render: function(){
  		
  		//console.log('THIS HERE', this.props);
  		var self = this;
  		
  		var callback_button = '';
  		
  		if(typeof this.props.job.is_filled != 'undefined'){
  			var categories = '';
  			var author = '';
  			var publish_date = '';
  			var apply_button = '';
  			var share_buttons = '';
  		} else {
  			var apply_button = (<JobApplyButton job={this.props.job} env_info={this.props.env_info} />);
  			var categories = (this.props.job.categories.length > 0) ? <JobCategories categories={this.props.job.categories} /> : '';
  			var author = (typeof this.props.job.posted_by != 'undefined') ? <JobAuthor  author={this.props.job.posted_by} job={this.props.job} /> : '';
  			var publish_date = (<JobPublishDate publish_date={this.props.job.publish_date} />);
  			var share_buttons = (<JobShare env_info={this.props.env_info} env={this.props.env} job={this.props.job} />);
  		}
  		
  		if(typeof this.props.job.hide_posted_on_date != 'undefined' && (this.props.job.hide_posted_on_date === true || this.props.job.hide_posted_on_date === 'true')){
	  		publish_date = "";
  		}
  		
  		if(typeof this.props.job.custom_callback_button != 'undefined' && this.props.job.custom_callback_button != ''){
  			callback_button = (<JobCallbackButton env_info={this.props.env_info} env={this.props.env} job={this.props.job} />);
  		}
  		
  		var custom_fields_top_el = null;
  		var custom_fields_bottom_el = null;
  		
  		if(self.props.job.custom_fields){
  			
  			var sidebar_top = _.filter(self.props.job.custom_fields, function(r){ 
  				return r.display_position === 'sidebar_top' && r.value !== '';
  			});
  			
  			var sidebar_bottom = _.filter(self.props.job.custom_fields, function(r){ 
  				return r.display_position === 'sidebar_bottom' && r.value !== '';
  			});
  			  			
  			if(sidebar_top.length > 0){
	  			custom_fields_top_el = (<ul className="custom-fields sidebar_top">
	  				{sidebar_top.map(function(cf){
		  				return (<li key={cf.field}>
		  					<h4>{cf.title}</h4>
		  					<span>{cf.value}</span>
		  				</li>);
	  				})}
	  			</ul>);
  			}
  			
  			if(sidebar_bottom.length > 0){
	  			custom_fields_bottom_el = (<ul className="custom-fields sidebar_bottom">
	  				{sidebar_bottom.map(function(cf){
		  				return (<li key={cf.field}>
		  					<h4>{cf.title}</h4>
		  					<span>{cf.value}</span>
		  				</li>);
	  				})}
	  			</ul>);
  			}
  		}
  		
   		return (
   			<div className="apply-area">
      			
      			{apply_button}
      			
      			{callback_button}
      			
      			{custom_fields_top_el}
      			
      			{publish_date}
      			
      			{author}
      			
      			{share_buttons}
      			
      			{categories}
      			
      			{custom_fields_bottom_el}
      			
	  			<OtherJobs env_info={this.props.env_info} other_jobs={this.props.other_jobs} env={this.props.env} />
	  			
	  			<PoweredBy />
	  			
	  			<div className="clear"></div>
	  		</div>
	  	);
	}
});
